// src/components/popups/DeletePostDrawer.js

import React from 'react';
import './DeletePostDrawer.css'; // Scoped CSS

function DeletePostDrawer({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="deletepost-overlay">
      <div className="deletepost-popup">
        <div className="deletepost-header">
          <h3>Delete Post</h3>
        </div>
        <div className="deletepost-body">
          <p>Are you sure you want to delete this post? It will be permanently removed.</p>
        </div>
        <div className="deletepost-footer">
          <button className="deletepost-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="deletepost-confirm-btn" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default DeletePostDrawer;
